/** Hard cap from the BFF: a filter that matches more employees than this must be narrowed. */
export const MAX_FILTERED_EMPLOYEES = 10000;

export const CUSTOM_FIELD_FILTER_QUERY_KEY = 'customFieldFilter';

/** Page size used when listing filterable field definitions by usage. */
export const FIELDS_BY_USAGE_PAGE_SIZE = 500;

/** Blade date-picker portal must stack above the run-payroll page chrome. */
export const DATE_PICKER_PORTAL_Z_INDEX = 2000;

/** Fallback section title for definitions without a section/group. */
export const DEFAULT_FIELD_SECTION = 'Custom Fields';
